import { render, staticRenderFns } from "./RevenueClient.vue?vue&type=template&id=19f02672"
import script from "./RevenueClient.vue?vue&type=script&lang=js"
export * from "./RevenueClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports